import {styled} from '@esgi/ui/theme';
import {Button as ButtonUI} from '@esgi/ui';

export const Button = styled(ButtonUI, {
	margin: '0 auto',
	maxWidth: '166px',
	width: '100%',
});
